/**
 * Analytics and Conversion Tracking Module
 * Handles click and interaction telemetry, pushing to dataLayer and gtag
 *
 * @package Gina_Theme
 */
(function() {
  'use strict';

  function initAnalytics() {
    window.dataLayer = window.dataLayer || [];

    // Global delegated event listener for analytics tracking
    document.addEventListener('click', function(event) {
      const trackingTarget = event.target.closest('[data-analytics-event], [data-analytics-action]');
      if (!trackingTarget) return;

      const eventType = trackingTarget.getAttribute('data-analytics-event') || 'click';
      const category = trackingTarget.getAttribute('data-analytics-category') || 'Interaction';
      const action = trackingTarget.getAttribute('data-analytics-action') || 'click';
      const label = trackingTarget.getAttribute('data-analytics-label') || (trackingTarget.textContent || '').trim();

      const telemetryPayload = {
        event: 'gina_interaction',
        event_type: eventType,
        event_category: category,
        event_action: action,
        event_label: label,
        timestamp: Date.now()
      };

      // 1. Push to Google Tag Manager dataLayer
      if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push(telemetryPayload);
      }

      // 2. Push to Google Analytics gtag if initialized
      if (typeof window.gtag === 'function') {
        window.gtag('event', action, {
          event_category: category,
          event_label: label,
          transport_type: 'beacon'
        });
      }

      // 3. Dispatch native DOM CustomEvent for custom integrations
      try {
        const customEvent = new CustomEvent('gina:analytics', {
          bubbles: true,
          detail: telemetryPayload
        });
        trackingTarget.dispatchEvent(customEvent);
      } catch (err) {
        // Fallback for older browsers
      }

      // 4. Debug output in development / localhost
      if (location.hostname === 'localhost' || location.hostname === '127.0.0.1' || location.search.indexOf('debug_analytics=1') !== -1) {
        console.info('[Gina Analytics]', telemetryPayload);
      }
    }, { passive: true });
  }

  window.GinaAnalytics = { init: initAnalytics };
})();
